import React, { Fragment, memo, type ReactNode } from 'react'
import tw from 'twin.macro'
import { Divider } from '@mui/material'
import { colors } from 'src/theme'
import type { CollectedData } from 'src/interfaces/collectedData'
import {
  ContractorStepDetailsCardUsageVariant,
  type ContractorStepDetailsCardStatus,
} from '../types'
import { ContractorStepDetailsBaseContentBlock } from './ContractorStepDetailsBaseContentBlock'

export interface SubmissionBlock {
  status: ContractorStepDetailsCardStatus
  showReviewButtonWithText?: boolean
  expiresAt?: string
  effectiveAt?: string
  collectedData?: CollectedData | null
  onReviewStepDataAction?: () => void | Promise<void>
  actions?: ReactNode
  showRecollectButton?: boolean
}

export interface ContractorStepDetailsCardContentProps {
  usageVariant: ContractorStepDetailsCardUsageVariant
  contentBlocks: SubmissionBlock[]
}

const ContractorStepDetailsCardContentComponent = ({
  usageVariant,
  contentBlocks,
}: ContractorStepDetailsCardContentProps) => {
  const blocks = contentBlocks

  if (!blocks.length) {
    return null
  }

  return (
    <div
      css={[
        tw`flex flex-col rounded-lg min-w-0 w-full overflow-hidden mt-4 border border-solid`,
        { borderColor: colors.SHADES_GREY_100 },
      ]}
    >
      {blocks.map((block, index) => (
        <Fragment key={`${block.status}-${block.expiresAt}-${index}`}>
          {index > 0 && (
            <Divider css={[tw`mt-0 mb-0 w-full`, { borderColor: colors.SHADES_GREY_100 }]} />
          )}
          <ContractorStepDetailsBaseContentBlock block={block} usageVariant={usageVariant} />
        </Fragment>
      ))}
    </div>
  )
}

export const ContractorStepDetailsCardContent = memo(ContractorStepDetailsCardContentComponent)
